/** Diálogo de contexto del superadmin (ADR-0003): toma la sucursal con motivo auditado y lleva al panel. */
import { ShieldAlert } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { AyudaVentana } from '@/ayuda/BotonAyuda.tsx';
import { Button } from '@/componentes/ui/button.tsx';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/componentes/ui/dialog.tsx';
import { Input } from '@/componentes/ui/input.tsx';
import { Campo } from '@/componentes/ui/label.tsx';
import { mensajeDeError } from '@/lib/api.ts';
import { useAuth } from '@/lib/auth.tsx';

export const MOTIVO_POR_DEFECTO = 'Operación desde la consola';

export function DialogoOperarSucursal({ sucursal, cerrar, alTomar, motivoInicial = MOTIVO_POR_DEFECTO }: { sucursal: { id: string; nombre: string } | null; cerrar: () => void; alTomar?: () => void; motivoInicial?: string }) {
  const { tomarContexto } = useAuth();
  const navigate = useNavigate();
  const [motivo, setMotivo] = useState(motivoInicial);
  const [enviando, setEnviando] = useState(false);

  // Cada vez que se abre para otra sucursal, el motivo vuelve al valor por defecto
  useEffect(() => {
    if (!sucursal) return;
    const t = setTimeout(() => setMotivo(motivoInicial), 0);
    return () => clearTimeout(t);
  }, [sucursal, motivoInicial]);

  const confirmar = async () => {
    if (!sucursal) return;
    setEnviando(true);
    try {
      await tomarContexto(sucursal.id, motivo.trim());
      toast.success(`Operando ${sucursal.nombre} como superadmin`, { description: 'Todas tus acciones quedan auditadas.' });
      cerrar();
      if (alTomar) alTomar();
      else navigate('/');
    } catch (e) {
      toast.error('No se pudo tomar el contexto', { description: mensajeDeError(e) });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Dialog open={!!sucursal} onOpenChange={(o) => !o && cerrar()}>
      <DialogContent>
        <DialogHeader>
          <div className="flex items-center gap-1">
            <DialogTitle className="flex items-center gap-2">
              <ShieldAlert className="h-5 w-5 text-mg-ambar" /> Operar {sucursal?.nombre} como superadmin
            </DialogTitle>
            <AyudaVentana tema="consolidado.operar" />
          </div>
          <DialogDescription>Operarás esta sucursal por tiempo limitado; al vencer vuelves a la consola global. Todo lo que hagas queda en la auditoría con tu usuario.</DialogDescription>
        </DialogHeader>
        <Campo etiqueta="Motivo" htmlFor="motivo" ayuda="Queda en la auditoría. Puedes dejar el motivo por defecto o escribir uno específico.">
          <Input id="motivo" value={motivo} onChange={(e) => setMotivo(e.target.value)} placeholder="Ej. revisar cierre de caja" data-testid="motivo-contexto" />
        </Campo>
        <DialogFooter>
          <Button variant="outline" onClick={cerrar}>
            Cancelar
          </Button>
          <Button onClick={() => void confirmar()} cargando={enviando} disabled={motivo.trim().length < 3} data-testid="confirmar-contexto">
            Operar {sucursal?.nombre}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
